var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13398 17.0612C3.24893 17.6267 2.08301 18.4079 2.08301 19.2708C2.08301 20.9967 6.74671 22.3958 12.4997 22.3958C18.2526 22.3958 22.9163 20.9967 22.9163 19.2708C22.9163 18.4079 21.7504 17.6267 19.8654 17.0612",
    stroke: "#272848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.2291C12.5003 18.2291 19.2712 13.8041 19.2712 8.68842C19.2712 5.04052 16.2398 2.08331 12.5003 2.08331C8.7609 2.08331 5.72949 5.04052 5.72949 8.68842C5.72949 13.8041 12.5003 18.2291 12.5003 18.2291Z",
    stroke: "#272848",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 11.4583C13.9379 11.4583 15.1038 10.2924 15.1038 8.85417C15.1038 7.41594 13.9379 6.25 12.4997 6.25C11.0614 6.25 9.89551 7.41594 9.89551 8.85417C9.89551 10.2924 11.0614 11.4583 12.4997 11.4583Z",
    stroke: "#272848",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.98e53d4c7851fb7913db178fecd34e90.svg";
export { ForwardRef as ReactComponent };